// Shared helpers for push-notification prompts
export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
export const isStandalone = () => window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
// iOS Safari only supports web push once the site is installed to the Home Screen
export const needsHomeScreen = () => isIOS() && !isStandalone();

const SNOOZE_MS = 14 * 24 * 60 * 60 * 1000;

export const isSnoozed = (key) => {
  const until = Number(localStorage.getItem(key) || 0);
  return until > Date.now();
};
export const snooze = (key) => localStorage.setItem(key, String(Date.now() + SNOOZE_MS));

export const PROMPT_SNOOZE_KEY = 'push:promptSnoozedUntil';
export const CHAT_NUDGE_KEY = 'push:chatNudgeSnoozedUntil';
